// assets
import {
  EyeOutlined,
  EditOutlined,
  ScheduleOutlined,
  CalendarOutlined,
} from "@ant-design/icons";

// icons
const icons = {
  EyeOutlined,
  EditOutlined,
  ScheduleOutlined,
  CalendarOutlined,
};

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const reservations = {
  id: "reservations",
  title: "Reservations",
  type: "group",
  children: [
    {
      id: "reservations",
      title: "Reservation List",
      type: "collapse",
      url: "/reservations",
      icon: icons.ScheduleOutlined,
      children: [
        // hidden items for breadcrumbs only
        {
          id: "edit-reservation",
          title: "Edit Reservation",
          type: "item",
          url: "/editReservation",
          icon: icons.EditOutlined,
          hidden: true,
        },
        {
          id: "show-reservation",
          title: "Reservation Data",
          type: "item",
          url: "/showReservation",
          icon: icons.EyeOutlined,
          hidden: true,
        },
      ],
    },
    {
      id: "calendar",
      title: "Calendar",
      type: "item",
      url: "/calendar",
      icon: icons.CalendarOutlined,
    },
  ],
};

export default reservations;
